import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Login';
import Register from './Components/Register'; // new import
import Main from './Components/Main';
import './App.css';

function App() {
  const isLoggedIn = sessionStorage.getItem('token') ? true : false;
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} /> {/* new route */}
        <Route path="/*" element={isLoggedIn ? <Main /> : <Navigate to="/login" />} /> 
        <Route path="*" element={<Navigate to={isLoggedIn ? "/" : "/login"} />} /> 
      </Routes>
    </Router>
  );
}

export default App;
